import { Box, Typography, TextField, Button, Grid, Select, MenuItem, Alert, Paper } from "@mui/material";
import { useState } from "react";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { useAuth } from "../../../context/AuthContext";
import api from "../../../services/api";

export default function LoanPage() {
  useProtectedRoute();
  const { token } = useAuth();
  const [amount, setAmount] = useState<number>(0);
  const [method, setMethod] = useState<string>('bank');
  const [term, setTerm] = useState<'short'|'long'>('long');
  const [lender, setLender] = useState<string>('');
  const [note, setNote] = useState<string>('');
  const [msg, setMsg] = useState<string>('');

  const submit = async () => {
    try {
      await api.post('/finance/loan', { amount, method, term, lender, note }, { headers: { Authorization: `Bearer ${token}` } });
      setMsg('Loan recorded successfully.');
      setAmount(0); setNote(''); setLender('');
    } catch (e: any) {
      alert(e?.response?.data?.message || 'Failed to record loan');
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight={800} mb={2}>Loan (Funds Received)</Typography>
      {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
      <Paper className="p-4">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}><TextField label="Amount" type="number" value={amount} onChange={(e)=>setAmount(Number(e.target.value))} fullWidth /></Grid>
          <Grid item xs={12} sm={3}>
            <Select fullWidth value={method} onChange={(e)=>setMethod(e.target.value as string)}>
              <MenuItem value="cash">Cash</MenuItem>
              <MenuItem value="bank">Bank</MenuItem>
              <MenuItem value="mobile">Mobile Money</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Select fullWidth value={term} onChange={(e)=>setTerm(e.target.value as any)}>
              <MenuItem value="short">Short-Term</MenuItem>
              <MenuItem value="long">Long-Term</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={3}><TextField label="Lender (optional)" value={lender} onChange={(e)=>setLender(e.target.value)} fullWidth /></Grid>
          <Grid item xs={12}><TextField label="Note" value={note} onChange={(e)=>setNote(e.target.value)} fullWidth /></Grid>
        </Grid>
        <Box mt={3}><Button variant="contained" onClick={submit} disabled={!amount || amount<=0}>Record Loan</Button></Box>
      </Paper>
    </Box>
  );
}

